import styled from 'styled-components';
import { PALLETE } from '../../../configs/configs';
import utils from '../../../helper/utils'
const { responsive, dataTypes } = utils

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .row {
    padding: 35px 0;
    display: flex;
    justify-content: space-between;
    @media (max-width: 450px) {
      padding: 16px 0;
      align-items: flex-end;
  }
  }

  .arrow-down {
    ${(props) => {
      if (props.color) return dataTypes.color.filterGenerator(props.color);
      return 'filter: none';
    }};
  }

  .column {
    display: flex;
    flex-direction: column;
    /* border-bottom: 1px solid ${PALLETE.pureWhite}; */
    border-bottom: ${(props) => {
        if (props.isWhiteTable) return `1px solid #EEEEEE`;
        return `1px solid ${PALLETE.pureWhite}`;
      }};
  }

  .smallColumn {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .hidden-text {
    font-weight: 300;
    font-size: 24px;
    margin: 0;
    color: ${PALLETE.inputGrey};
    text-align: justify;
    @media (max-width: 450px) {
      font-size: ${responsive.ajustFont(12)}px;
    }
  }

  img {
    &:hover {
      cursor: pointer;
    }
  }

  .text {
    font-weight: 400;
    font-size: 32px;
    color: ${PALLETE.pureWhite};
    margin: 0;
    @media (max-width: 450px) {
      font-weight: 700;
      font-size: ${responsive.ajustFont(16)}px;
      text-align: left;
      color: ${(props) => {
        if (props.isWhiteTable) return PALLETE.inputGrey;
        return PALLETE.pureWhite;
      }};
    }
  }

  .mobile-legend {
    text-align: left;
    font-weight: 400;
      font-size: ${responsive.ajustFont(12)}px;
      color: ${(props) => {
        if (props.isWhiteTable) return PALLETE.inputGrey;
        return '#9e9e9e'
      }};
      margin:0 0 6px 0;
  }

  @media (max-width: 450px) {
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  transition: max-height 0.5s;
  width: 100%;
  padding: ${(props) => {
    if (props.extended) return '0 0 30px 0';
    return '0';
  }};
  max-height: ${(props) => {
    if (props.extended) return '192px';
    return '0';
  }};
  overflow: hidden;

  @media (max-width: 450px) {
    padding: ${(props) => {
    if (props.extended) return '0 0 16px 0';
    return '0';
  }};
  }
`;
